import React from 'react';
import { css } from 'react-emotion';
import { fonts } from '@peachjar/components';

const styles = {
  heading: css({
    fontFamily: fonts.ProximaNovaA,
    fontSize: fonts.pjFontSize07,
    paddingTop: '3rem',
    paddingBottom: '3rem',
    fontWeight: 400,
  }),
};

const HeadingText = ({ paymentAssigneeName, isPaymentAssigneePresent }) => (
  <div className={styles.heading}>
    {isPaymentAssigneePresent
      ? `Hi ${paymentAssigneeName}, please complete the payment process below.`
      : 'Order Authorization and Payment'}
  </div>
);

export default HeadingText;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Payment/components/HeadingText.jsx